import React from 'react';

const SigningComplete = () => (
  <div style={{ maxWidth: 480, margin: '80px auto', padding: 24, textAlign: 'center' }}>
    <h1 style={{ fontSize: 22, marginBottom: 12 }}>Thank you</h1>
    <p style={{ color: '#374151', fontSize: 16 }}>
      Your signature has been recorded. You may close this window.
    </p>
  </div>
);

export default SigningComplete;
